import { RemoteUpdatePartnerRequest } from 'data/usecases/partners';
import { makeApiUrlPartnerRequests } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeRemoteUpdatePartnerRequest = (): RemoteUpdatePartnerRequest => {
  return new RemoteUpdatePartnerRequest(
    makeApiUrlPartnerRequests(),
    makeAxiosHttpClient(),
  );
};
